export const config = {
  appShortName: 'MyPASM',
  appFullName: 'Pentaksiran Alternatif Sekolah Menengah',
  organizationName: 'Government of Malaysia',
  companyName: 'Lembaga Peperiksaan',
  companyShortName: null,
  yearReleased: '2022',
  appVersion: '1.0.8',
  appBuildNumber: 9,
  api: '/api/',
};
